export const themeSchema = {
  palette: {
    label: "T_COLOUR_PALETTE",
    value: {
      primary: {
        label: "T_PRIMARY_CHOICE",
        description: "T_PRIMARY_CHOICE_DESC",
      },
      secondary1: {
        label: "T_SECONDARY_CHOICE_1",
        description: "T_SECONDARY_CHOICE_1_DESC",
      },
      secondary2: {
        label: "T_SECONDARY_CHOICE_2",
        description: "T_SECONDARY_CHOICE_2_DESC",
      },
    },
  },
  disabled: {
    label: "T_COLOUR_DISABLED",
    value: {
      primaryDisabled: {
        label: "T_PRIMARY_DISABLED_CHOICE",
        description: "T_PRIMARY_DISABLED_CHOICE_DESC",
      },
      secondaryDisabled: {
        label: "T_SECONDARY_DISABLED_CHOICE",
        description: "T_SECONDARY_DISABLED_CHOICE_DESC",
      },
    },
  },
  hover: {
    label: "T_COLOUR_HOVER",
    value: {
      primaryHover: {
        label: "T_PRIMARY_HOVER_CHOICE",
        description: "T_PRIMARY_HOVER_CHOICE_DESC",
      },
      secondaryHover: {
        label: "T_SECONDARY_HOVER_CHOICE",
        description: "T_SECONDARY_HOVER_CHOICE_DESC",
      },
    },
  },

  text: {
    label: "T_COLOUR_TEXT",
    value: {
      primaryTextColor: {
        label: "T_PRIMARY_TEXT_CHOICE",
        description: "T_PRIMARY_TEXT_CHOICE_DESC",
      },
      secondary1TextColor: {
        label: "T_SECONDARY_TEXT_CHOICE",
        description: "T_SECONDARY_TEXT_CHOICE_DESC",
      },
    },
  },
};

export const themeJSON = {
  primary: "#1745D1",
  primaryDisabled: "#ABC6DE",
  primaryHover: "#0074E0",
  primaryTextColor: "#FFFFFF",
  secondary1: '#1745D1',
  secondary1TextColor: '#1A3E6C',
  secondary2: "#F1EFEA",
  secondaryDisabled: "#C2D4E8",
  secondaryHover: "#FCFCFC",
  whiteColor: "#FFFFFF",
};
